<template>
  <el-dialog :visible="display" @open="open" @closed="closed" @close="$emit('close', false)" @opened="opened"
             destroy-on-close append-to-body :close-on-press-escape="false" :close-on-click-modal="false" fullscreen>
    <template #title>
      <h3 class="text-center">{{ $t('supply.title.receive', { code: po.code }) }}</h3>
      <hr>
    </template>
    <el-row>
      <el-col :span="16" :offset="4">
        <el-row type="flex" class="mb-2">
          <el-col :span="8" class="mb-1">
            <el-date-picker ref="dateRef" v-model="date" type="date" :placeholder="$t('supply.label.date')"/>
          </el-col>
          <v-spacer/>
          <el-col :span="4" align="right" class="mb-1 pt-2">
            <el-button type="info" size="small" icon="el-icon-arrow-down" @click="autofillReceivable" plain round>
              {{ $t('supply.button.receive_all') }}
            </el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="16" :offset="4">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th scope="col" class="text-center">#</th>
              <th scope="col">{{ $t('supply.table.item') }}</th>
              <th scope="col" class="text-center">{{ $t('supply.table.ordered') }}</th>
              <th scope="col" class="text-center">{{ $t('supply.table.received') }}</th>
              <th scope="col" class="text-center">{{ $t('supply.table.receivable') }}</th>
              <th scope="col" class="text-center">{{ $t('supply.table.unit_price') }}</th>
              <th scope="col" class="text-center">{{ $t('supply.table.to_receive') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in receivableItems">
              <td align="center">{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td align="center">{{ item.ordered }}</td>
              <td align="center">{{ item.received }}</td>
              <td align="center">{{ item.receivable }}</td>
              <td align="center" style="width: 120px">
                <v-text-field v-model.number="receivableItems[index].unit_price" hide-details class="pt-0 mt-0"/>
              </td>
              <td align="center">
                <el-input-number size="small" v-model="receivableItems[index].quantity" :min="0"
                                 :max="item.receivable"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </el-col>
    </el-row>
    <el-row v-show="additionalCost.length">
      <el-col :span="16" :offset="4">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="">
            <tr>
              <th scope="col" colspan="2">{{ $t('supply.label.additional_cost') }}</th>
              <th scope="col" class="text-center">{{ $t('supply.label.amount') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in additionalCost">
              <td align="center" style="width: 5px;">
                <el-checkbox :disabled="item.disabled" v-model="item.applied"/>
              </td>
              <td>{{ item.name }}</td>
              <td align="center">
                {{ item.amount | currency('', 0) }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="16" :offset="4">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="">
            <tr>
              <th scope="col" colspan="2">{{ $t('supply.label.attachment') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td width="50%">
                <v-text-field :placeholder="$t('supply.label.reference')" v-model="reference" hide-details/>
              </td>
              <td>
                <v-file-input ref="attachmentRef" :label="$t('supply.label.add_attachment')" v-model="attachment"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </el-col>
    </el-row>
    <template #footer>
      <el-row class="dialog-footer">
        <el-col :span="12" :offset="6">
          <el-button :loading="loading" @click="$emit('close', false)" type="danger" plain>
            {{ $t('button.cancel') }}
          </el-button>
          <el-button :disabled="!dataIsSavable" :loading="loading" type="primary" @click="receiveItems">
            {{ $t('supply.button.receive') }}
          </el-button>
        </el-col>
      </el-row>
    </template>
  </el-dialog>
</template>
<script>

export default {
  name: 'ReceiveDialog',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    po: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      receivableItems: [],
      additionalCost: [],
      attachment: null,
      base64Attachment: null,
      date: null,
      reference: ''
    }
  },
  watch: {
    attachment (value) {
      if (value && typeof value === 'object') {
        this.encodeFileAsURL(value)
      } else {
        this.base64Attachment = null
      }
    }
  },
  computed: {
    dataIsSavable () {
      return (this.receivableItems.some(rc => rc.quantity > 0) > 0 ||
        this.additionalCost.some(ad => ad.applied && !ad.is_applied) > 0)
    }
  },
  methods: {
    open () {
    },
    opened () {
      this.po.items.forEach(item => {
        let received = []
        this.po.received.forEach(ri => {
          received = [...received, ...ri.items.filter(i => (i.item_id === item.item_id && i.quantity > 0))]
        })
        if (received.length) {
          const totalReceived = received.map(rc => rc.quantity).reduce((a, b) => a + b, 0)
          this.receivableItems.push({
            id: item.item_id,
            name: item.item.name,
            ordered: item.quantity,
            received: totalReceived,
            receivable: item.quantity - totalReceived,
            unit_price: item.unit_price,
            quantity: null
          })
        } else {
          this.receivableItems.push({
            id: item.item_id,
            name: item.item.name,
            ordered: item.quantity,
            received: 0,
            receivable: item.quantity,
            unit_price: item.unit_price,
            quantity: null
          })
        }
      })
      this.po.additional_cost.forEach(add => {
        this.additionalCost.push({
          ...add,
          applied: add.is_applied,
          disabled: (add.is_applied || add.is_cancelled)
        })
      })
    },
    closed () {
      this.receivableItems = []
      this.additionalCost = []
      this.attachment = null
      this.data = null
      this.reference = ''
      this.base64Attachment = null
    },
    autofillReceivable () {
      for (const item of this.receivableItems) {
        item.quantity = item.receivable
      }
      for (const cost of this.additionalCost) {
        if (!cost.is_applied && !cost.is_cancelled && !cost.applied) {
          cost.applied = true
        }
      }
    },
    encodeFileAsURL (file, loc) {
      const reader = new FileReader()
      reader.onloadend = () => {
        this.base64Attachment = reader.result
        return false
      }
      reader.readAsDataURL(file)
    },
    dataIsValid () {
      if (this.dataIsSavable && this.date) {
        return true
      }
      this.$refs.dateRef.focus()
      return false
    },
    async receiveItems () {
      if (this.dataIsValid()) {
        try {
          await this.withLoading(async () => {
            const data = await this.$supplyService.receivedItems(this.po.id, {
              items: this.receivableItems,
              additional_cost: this.additionalCost.filter(it => it.applied && it.is_pending),
              attachment: this.base64Attachment,
              date: this.date,
              reference: this.reference
            })
            this.$emit('updated', data)
            this.$emit('close', false)
            this.closed()
          }, 'loading')
        } catch (error) {
          // Error is already handled by the global interceptor
          console.log('Component caught error in receiveItems:', error)
        }
      }
    },
    async withLoading (callback, loadingText) {
      this.loading = true
      try {
        await callback()
      } finally {
        this.loading = false
      }
    },
    showSuccess (message) {
      this.$message.success(message)
    }
  },
  mounted () {
  }
}
</script>

<style>
.el-input-number__decrease {
  left: 1px!important;
}
</style>
